import {NavLink, Route, Switch, Redirect, useLocation} from 'react-router-dom';
import {Container, Row, Col} from 'reactstrap';
import {useEffect} from 'react';
import JurorVoteCountBanner from '../../../components/JurorVoteCountBanner/JurorVoteCountBanner';
import styles from './JuryShell.module.scss';
import {useFeatureFlag, useJurorLimits} from "../../../shared/config";
import useJuryStore from '../../../store/juryStore';
import JuryBadge from '../../../components/JuryBadge/JuryBadge';

function JuryShell({routes}) {
    const location = useLocation();
    const {voteLimit, voteLimitPerProject} = useJurorLimits();
    const setLimits = useJuryStore(s => s.setLimits);
    const bookmarks = useJuryStore(s => s.bookmarks);
    const votes = useJuryStore(s => s.votes);
    const bookmarkCount = bookmarks.size;
    const votedCount = Object.values(votes).filter(v => v > 0).length;

    useEffect(() => {
        setLimits(voteLimit, voteLimitPerProject);
    }, [voteLimit, voteLimitPerProject, setLimits]);

    if (useFeatureFlag('juryVoting') === false) return (<Redirect to="/"/>)

    const showNavigation = location.pathname !== '/jury/login';
    return (
        <Container fluid className="px-0">
            <JurorVoteCountBanner/>

            {showNavigation && (
                <div className={styles.NavigationWrapper}>
                    <Container>
                        <Row className="py-3">
                            <Col>
                                <nav className={styles.NavMenu}>
                                    <NavLink
                                        to="/jury/teilnehmer"
                                        className={styles.NavItem}
                                        activeClassName={styles.NavItemActive}
                                    >
                                        Teilnehmer
                                    </NavLink>
                                    <NavLink
                                        to="/jury/merkliste"
                                        className={styles.NavItem}
                                        activeClassName={styles.NavItemActive}
                                    >
                                        Merkliste
                                        {bookmarkCount > 0 && (
                                            <JuryBadge>{bookmarkCount}</JuryBadge>
                                        )}
                                    </NavLink>
                                    <NavLink
                                        to="/jury/abstimmung"
                                        className={styles.NavItem}
                                        activeClassName={styles.NavItemActive}
                                    >
                                        Abstimmung
                                        {votedCount > 0 && (
                                            <JuryBadge>{votedCount}</JuryBadge>
                                        )}
                                    </NavLink>
                                    <NavLink
                                        to="/jury/rahmenbedingungen"
                                        className={styles.NavItem}
                                        activeClassName={styles.NavItemActive}
                                    >
                                        Rahmenbedingungen
                                    </NavLink>
                                </nav>
                            </Col>
                        </Row>
                    </Container>
                </div>
            )}

            <Switch>
                {routes.map(({path, component: Component}) => (
                    <Route
                        key={path}
                        path={path}
                        render={(props) => <Component {...props} />}
                    />
                ))}
                <Redirect from="/jury" to="/jury/teilnehmer" exact/>
            </Switch>
        </Container>
    );
}

export default JuryShell;
